import { Box, Divider } from "@braintrust/braintrust-ui-components";
import { useAccountType } from "@js/apps/common/hooks";
import type { OfferCommon } from "@js/types/jobs";

import { InfoRow } from "./info-row";
import { OfferPreviewSectionContainter } from "./section-container";

type AdditionalInfoProps = {
  offer: OfferCommon;
  bottomSocket?: React.ReactNode;
};

export const AdditionalInfo = ({
  offer,
  bottomSocket,
}: AdditionalInfoProps) => {
  const { isFreelancer } = useAccountType();

  const paperworkLabel = offer.require_paperwork
    ? "Additional paperwork required — Braintrust will follow up"
    : "No extra paperwork required";

  const equipmentLabel = offer.talent_has_own_equipment
    ? isFreelancer
      ? "You will use your own equipment"
      : "Talent will use their own equipment"
    : "Some equipment will be provided";

  return (
    <OfferPreviewSectionContainter title="📎 Additional info">
      <InfoRow label={paperworkLabel} />
      <Divider color="beige" />
      <InfoRow label={equipmentLabel} />
      {!!bottomSocket && <Box sx={{ pl: 3 }}>{bottomSocket}</Box>}
    </OfferPreviewSectionContainter>
  );
};
